import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import { MCard } from "components/Shared";
import { userHasRight } from "selectors/rights";
import { CUSTOMER_ACCOUNT_EDIT } from "typeConstants/rights";
import { NameNumberDto } from "interfaces/Mueller.Business.Models.ts";
import { getCustomerExperienceDirector, getCustomerExperienceManager } from "requests/employeeCustomerSurveyTypes/index.tsx";

// This card is readonly as these assignments are handled through employee mappings

interface CustomerExperienceAssignmentProps {
  verticalDisplay: boolean;
  customerNumber: number; 
  surveyTypeCode: string | undefined; // If provided, card will display assigned manager
  // Redux
  canEdit: boolean;
}

const CustomerExperienceAssignment = (props: CustomerExperienceAssignmentProps) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [director, setDirector] = useState<NameNumberDto>(null);
  const [manager, setManager] = useState<NameNumberDto>(null);
  const mounted = useRef(true);

  useEffect(() => { 
    setIsLoading(true);
    if (props.customerNumber) {
      const handleDirector = (dir: NameNumberDto) => {
        setDirector(dir);
        setIsLoading(false);
      };
      getCustomerExperienceDirector(props.customerNumber, handleDirector, mounted);
    }
  }, [props.customerNumber]);

  useEffect(() => { 
    setIsLoading(true);
    if (props.customerNumber && props.surveyTypeCode) {
      const handleManager = (mgr: NameNumberDto) => {
        setManager(mgr);
        setIsLoading(false);
      }
      getCustomerExperienceManager(props.customerNumber, props.surveyTypeCode, handleManager, mounted);
    }
  }, [props.surveyTypeCode]);

  useEffect(() => { 
    return () => { mounted.current = false; };
  }, []);

  const fields = [
    { label: "Customer Experience Director", value: director ? `${director.firstName} ${director.lastName}` : null },
  ];
  if (props.surveyTypeCode) {
    fields.push( { label: "Customer Experience Manager", value: manager ? `${manager.firstName} ${manager.lastName}` : null });
  }


  const cellWidth = props.verticalDisplay ? 12 : 4;

  return (
    <MCard
      title={"Customer Experience Team"}
      cellWidth={cellWidth}
      fields={fields}
      isFetching={isLoading}
      children={
        props.canEdit ? <p>Please use Employee Mappings to change assignments</p> : <></>
      }
    />
  );
};


const mapStateToProps = state => ({
  canEdit: userHasRight(CUSTOMER_ACCOUNT_EDIT)(state),
});


export default connect(mapStateToProps, null)(CustomerExperienceAssignment);
